export default "__VITE_ASSET__CQM1VUzL__"